// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e10722ed","498":"e7126907","513":"c0f53746","787":"c2677e38"}[chunkId] + ".chunk.js";
};